<template>
  <div class="header-box">
    <div class="header-wrap">
      <a href="https://sos.kingsgroupgames.com" target="_blank" class="logo"></a>
      <div class="right-box">
        <PwaPrompt></PwaPrompt>
        <PwaPromptSafari></PwaPromptSafari>
        <a href="javascript:;" class="btn btn-header btn-install-pc" @click="toInstallPC">
          <span class="btn-header-icon"></span>
          <div class="btn-header-content">
            <div class="t">PLAY ON PC</div>
            <div class="b">ONLY FOR WINDOWS</div>
          </div>
        </a>
        <div class="btn btn-header entrance-wrapper" @click="isShowWelfareCenter = true" :class="{ 'active': userInfo.openid }">
          <div class="btn-header-icon award" :class="{ rotate: userInfo.openid }"></div>
          <div class="btn-header-content">
            {{ $t('boon-page-title') }}
          </div>
        </div>
        <a href="javascript:;" class="btn btn-header btn-recharge" :class="{ 'active': userInfo.openid }" @click="toStore">
          <span class="btn-header-icon"></span>
          <div class="discount" v-if="isFirstPay"></div>
          <div class="btn-header-content">
            {{ $t('btn-header-recharge') }}
          </div>
        </a>
        <a href="javascript:;" class="btn btn-header css-btn" :class="{ 'active': userInfo.uid && configJson && messageJson }" @click="openFaq">
          <span class="btn-header-icon"></span>
          <div class="btn-header-content">
            {{ $t('text_css_btn') }}
          </div>
        </a>
        <!-- 静音按钮 -->
        <a href="javascript:;" class="btn btn-header btn-header-s btn-mute" :class="{ 'mute': isMute, 'hide': !showMuteBtn }" @click="muteControl">
          <span class="btn-header-icon"></span>
        </a>
        <div class="tools-wrap">
          <div class="login-box">
            <div class="avatar"></div>
            <span class="name">{{ userInfo.name }}</span>
            <em class="icon-arrow-down"></em>
            <div class="menu">
              <a href="javascript:;" class="menu-item bind-account" @click="onBindAccountClick">{{ $t('lLinkAccount') }}</a>
              <a href="javascript:;" class="menu-item change-account" @click="changeAccount">{{ $t('lSwitchAccount') }}</a>
              <a v-if="loginType === 'account'" href="javascript:;" class="menu-item change-account" @click="logout">{{ $t('lLogout') }}</a>
            </div>
          </div>
        </div>
      </div>
      <!-- 切换账号 -->
      <Login v-if="showPopup === 'login'" @changePopup="changePopup" :data="dataPopup"></Login>
      <Verify v-else-if="showPopup === 'Verify'" @changePopup="changePopup" :data="dataPopup"></Verify>
      <Result v-else-if="showPopup === 'Result'" @changePopup="changePopup" @loginComplete="loginComplete" @localLogin="doVisitorLogin" :data="dataPopup"></Result>
      <!-- 绑定账号 -->
      <Account v-if="showPopup === 'bind'" @changePopup="changePopup"></Account>
    </div>

    <div class="welfare-wrapper" ref="welfareCenter">
      <WelfareCenter v-if="isShowWelfareCenter" @close="isShowWelfareCenter = false"></WelfareCenter>
    </div>
  </div>
</template>

<script>
import { v1 as uuidv1, v4 as uuidv4 } from 'uuid'
import { mapMutations, mapActions, mapState, mapGetters } from 'vuex'
import { plogin, socialLogin, fpid2openid, ameApiDo, storeLogin, storeInit } from '@/server/api'
import PwaPrompt from './PwaPrompt.vue'
import PwaPromptSafari from './PwaPromptSafari.vue'
import Login from '../popup/Login.vue'
import Verify from '../popup/Verify.vue'
import Result from '../popup/Result.vue'
import Account from '../popup/Account.vue'
import WelfareCenter from '../welfareCenter/Index.vue'

export default {
  name: 'Header',
  components: { PwaPrompt, PwaPromptSafari, Login, Verify, Result, Account, WelfareCenter },
  data () {
    const isMute = localStorage.getItem('mute-control') === 'off'
    return {
      showPopup: '',
      dataPopup: {
        from: ''
      },
      urlParams: {},
      timer: null,
      isShowWelfareCenter: false,
      isPushStoreLogin: false,
      isFirstPay: undefined,
      isMute,
      showMuteBtn: false
    }
  },
  computed: {
    ...mapGetters(['bindAccountNum']),
    ...mapState({
      configJson: state => state.faqConfig.configJson,
      messageJson: state => state.faqConfig.messageJson,
      userInfo: 'userInfo',
      loginType: 'loginType'
    })
  },
  created () {
    this.init()
    this.$bus.$on('first-load-game-start', () => {
      this.visitorCountDown()
    })
    this.$bus.$on('welfare-events', type => {
      if (type === 'toStore') this.toStore()
      else if (type === 'bindAccount') this.bindAccount()
      else if (type === 'hideFirstPayIcon') this.isFirstPay = false
    })
    this.setWelfareUnit = this.$utils.debounce(this.setWelfareUnit, 300)
  },
  mounted () {
    this.setWelfareUnit()
    window.addEventListener('resize', this.setWelfareUnit)
  },
  methods: {
    ...mapMutations({
      setHelpUrl: 'setHelpUrl',
      setFbFlag: 'setFbFlag',
      setUserInfo: 'setUserInfo',
      updateUserInfo: 'updateUserInfo',
      setBindInfo: 'setBindInfo',
      setLoginType: 'setLoginType',
      storeLogout: 'storeLogout'
    }),
    ...mapActions({
      FETCH_CONF: 'FETCH_CONF'
    }),
    initFacebook (lang) {
      /* eslint-disable */
      // 加载 facebook js
      (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = `https://connect.facebook.net/${lang}/sdk.js`;
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
      /* eslint-enable */
    },
    loadFBSDK (gid) {
      /* eslint-disable */
      const _this = this
      window.fbAsyncInit = function() {
        window.FB.init({
          appId      : _this.$ENUM.FACEBOOK_ACCOUNT_MAP[gid],
          cookie     : true,                     // Enable cookies to allow the server to access the session.
          xfbml      : true,                     // Parse social plugins on this webpage.
          version    : 'v13.0'           // Use this Graph API version for this call.
        })
        _this.setFbFlag(true)
      }
      /* eslint-enable */
    },
    init () {
      const urlParams = this.$utils.getParamsFromUrl()
      this.urlParams = urlParams
      // 帮助链接
      this.setHelpUrl({ gid: urlParams.gid })
      this.FETCH_CONF()
      this.initFacebook(urlParams.webLang || 'en_US')
      this.loadFBSDK(urlParams.gid)
      if (localStorage.getItem('social_login_params')) {
        this.doSocialLoginLocal()
      } else {
        this.doVisitorLogin()
      }
      this.$bus.$on('after-bind-visitor-login', (p) => {
        this.doSocialLogin(p, 'update-account-info')
        this.changePopup({ name: '' })
      })
      this.$bus.$on('already-bind-to-login', params => {
        this.doSocialLogin(params)
        // 切换账号时需要先关闭福利中心
        this.isShowWelfareCenter = false
      })
      this.$bus.$on('new-user-get-openid', params => {
        this.fpid2openid(params, 'new-user')
      })
      // 游戏消息通道准备好，可以显示静音控制按钮
      this.$bus.$on('message-channel-is-ready', () => {
        this.showMuteBtn = true
      })
    },
    visitorCountDown () {
      if (localStorage.getItem('login-type') === 'visitor' && localStorage.getItem('visitor-show-account-dialog-switch') !== '1') {
        console.log('==z==> 开始游戏 - 游客登录 - 准备倒计时！！')
        clearInterval(this.timer)
        this.timer = setInterval(() => {
          const [loginType, count, maxCount] = [localStorage.getItem('login-type'), localStorage.getItem('visitor-show-account-dialog-countdown') || 0, localStorage.getItem('visitor-show-account-dialog-countdown-max') || 600]
          if (loginType !== 'visitor') {
            clearInterval(this.timer)
            this.timer = null
            localStorage.removeItem('visitor-show-account-dialog-countdown')
            localStorage.setItem('visitor-show-account-dialog-switch', 1)
          } else if (loginType !== 'visitor' || Number(count) >= maxCount) {
            this.bindAccount()
            clearInterval(this.timer)
            this.timer = null
            localStorage.removeItem('visitor-show-account-dialog-countdown')
            localStorage.setItem('visitor-show-account-dialog-switch', 1)
          } else {
            localStorage.setItem('visitor-show-account-dialog-countdown', Number(count) + 1)
          }
        }, 1000)
      }
    },
    // 点击切换账号按钮
    changeAccount () {
      this.checkDeviceInfo()
      this.showPopup = 'login'
      this.dataPopup.from = 'switch'
    },
    // 点击绑定账号按钮
    onBindAccountClick () {
      localStorage.setItem('log-bind-entry', 'icon')
      this.bindAccount()
    },
    bindAccount () {
      this.checkDeviceInfo()
      this.showPopup = 'bind'
      this.$utils.log('bind_account', { bind_channel: 'icon' })
    },
    // 检查本地social_login的deviceId和deviceUUID
    checkDeviceInfo () {
      const deviceId = localStorage.getItem('social-did')
      const deviceUuid = localStorage.getItem('social-duuid')
      if (!deviceId) {
        localStorage.setItem('social-did', uuidv1().replaceAll('-', ''))
      }
      if (!deviceUuid) {
        localStorage.setItem('social-duuid', uuidv4().replaceAll('-', ''))
      }
    },
    // 切换弹窗 - 登录弹窗内发送验证码动作
    changePopup (data) {
      this.showPopup = data.name
      if (!data.keepData) {
        const { from } = { ...this.dataPopup }
        this.dataPopup = { from, ...(data.query || data.params) }
      }
    },
    loginComplete (res) {
      this.showPopup = ''
      this.fpid2openid(res.fpid)
    },
    // 游客登录
    doVisitorLogin () {
      console.log('==z==> visitor login')
      // 检查本地deviceId和deviceUUID
      let deviceId = localStorage.getItem('local-did')
      let deviceUuid = localStorage.getItem('local-duuid')
      if (!deviceId) {
        localStorage.setItem('local-did', uuidv1().replaceAll('-', ''))
      }
      if (!deviceUuid) {
        localStorage.setItem('local-duuid', uuidv4().replaceAll('-', ''))
      }
      deviceId = localStorage.getItem('local-did')
      deviceUuid = localStorage.getItem('local-duuid')
      // 游客登录login
      const params = {
        gameId: '30001',
        deviceId,
        deviceUuid
      }
      plogin(params)
        .then(res => {
          this.setUserInfo({
            name: `${this.$t('lGuest')}${deviceUuid.substring(0, 10)}`,
            ...res,
            loginType: 'guest_login'
          })
          this.setLoginType('visitor')
          this.setBindInfo(res.bindInfos)
          this.fpid2openid(res.fpid)
          if (res.isNew) {
            console.log('==z==> log web_install')
            const extraParams = {
              account_id: 0,
              is_login: 1,
              player_index: 0
            }
            const datailParams = {
              fpid: res.fpid
            }
            this.$utils.log('web_install', datailParams, extraParams)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // social device id 登录
    doSocialLoginLocal () {
      console.log('==z==> social device login')
      // 检查本地deviceId和deviceUUID
      let deviceId = localStorage.getItem('social-did')
      let deviceUuid = localStorage.getItem('social-duuid')
      if (!deviceId) {
        localStorage.setItem('social-did', uuidv1().replaceAll('-', ''))
      }
      if (!deviceUuid) {
        localStorage.setItem('social-duuid', uuidv4().replaceAll('-', ''))
      }
      deviceId = localStorage.getItem('social-did')
      deviceUuid = localStorage.getItem('social-duuid')
      const params = {
        gameId: '30001',
        deviceId,
        deviceUuid
      }
      plogin(params)
        .then(res => {
          const socialType = localStorage.getItem('social_login_type')
          console.log('==z==> social device login - res - socialInfo: ', String(socialType))
          const socialInfos = res.bindInfos.filter(x => x.bindType === socialType && String(socialType))
          let socialInfo = res.bindInfos.filter(x => x.bindInfo.name !== '' || x.bindInfo.email !== '')
          if (socialInfos.length > 0) {
            socialInfo = socialInfos[0].bindInfo
          } else {
            socialInfo = socialInfo[0].bindInfo
          }
          this.setUserInfo({
            name: socialInfo.name || socialInfo.email,
            ...res,
            loginType: 'social_login'
          })
          this.setLoginType('account')
          this.setBindInfo(res.bindInfos)
          this.fpid2openid(res.fpid)
        })
        .catch(err => {
          console.log(err)
        })
    },
    doSocialLogin (p, action) {
      console.log('==z==> social login')
      if (p) {
        // 自动登录 - 200018 重复绑定
        this.changePopup({ name: '' })
      }
      const params = p || JSON.parse(localStorage.getItem('social_login_params'))
      // 检查本地deviceId和deviceUUID
      let deviceId = localStorage.getItem('social-did')
      let deviceUuid = localStorage.getItem('social-duuid')
      if (!deviceId) {
        localStorage.setItem('social-did', uuidv1().replaceAll('-', ''))
      }
      if (!deviceUuid) {
        localStorage.setItem('social-duuid', uuidv4().replaceAll('-', ''))
      }
      deviceId = localStorage.getItem('social-did')
      deviceUuid = localStorage.getItem('social-duuid')
      params.deviceId = deviceId
      params.deviceUuid = deviceUuid
      socialLogin(params).then(res => {
        this.type = 'success'
        // 设置用户绑定信息
        this.setBindInfo(res.bindInfos)
        this.setLoginType('account')
        // 设置用户信息
        const bindInfo = res.bindInfos.filter(x => x.bindType === `${params.bindType}`)
        if (bindInfo.length > 0) {
          this.setUserInfo({
            name: bindInfo[0].bindInfo.name || bindInfo[0].bindInfo.email || '',
            ...res,
            loginType: 'social_login'
          })
        }
        this.fpid2openid(res.fpid, action)
        localStorage.setItem('social_login_params', JSON.stringify(params))
      }).catch(err => {
        this.type = 'fail'
        this.code = err.code
        // 游客登录
        this.doVisitorLogin()
        // 清理social login参数
        localStorage.removeItem('social_login_params')

        this.$gtag.event('PC_login', {
          login_game_id: this.urlParams.gid,
          login_type: 'web_login',
          login_code: err.code
        })
        console.error(JSON.stringify({
          type: 'axios',
          request: params,
          response: err
        }))
      })
    },
    // fpid转openid
    fpid2openid (fid, action) {
      console.log('==z==> fpid2openid')
      const fpid = this.$utils.string10to62(fid)
      fpid2openid({ fpid })
        .then(res => {
          if (res.openid_list && res.openid_list.length) {
            if (this.userInfo.openid !== res.openid_list[0].openid) {
              this.isShowWelfareCenter = false
            }
            localStorage.setItem('openid', res.openid_list[0].openid)
            this.setUserInfo({ openid: res.openid_list[0].openid, uid: res.openid_list[0].uid, real_pkg_channel: res.openid_list[0].pkg_channel })
            this.$bus.$emit('user-openid-updated', this.userInfo.fpid)
            if (res.openid_list[0].openid) {
              // 登录成功 & openid & bindinfo>0 时请求发(绑定)奖
              if (this.bindAccountNum > 0 && this.$ENUM.BIND_ACCOUNT_PKGCHANNEL.includes(res.openid_list[0].pkg_channel)) {
                const params = {
                  p0: 'web',
                  p1: this.$ENUM.AME_PROJECT_ID,
                  p2: this.$ENUM.AME_EVENT_MAP.BIND_ACCOUNT,
                  openid: res.openid_list[0].openid
                }
                ameApiDo(params)
                  .then(res => {
                    if (res.code === 0 && localStorage.getItem('log-bind-entry')) {
                      this.$utils.log('bind_account_reward', { bind_channel: localStorage.getItem('log-bind-entry') })
                    }
                  })
                  .finally(() => {
                    this.$bus.$emit('welfare-check-ame-bind')
                  })
              }
              // 检查是否还有首充
              const params = {
                price: 0.99,
                product_id: 'com.kingsgroup.pc.diamond0',
                game_id: 30001,
                game_project: 'ss_global',
                source: 'web',
                country: 'HK',
                currency: 'USD',
                openid: res.openid_list[0].openid,
                uid: parseInt(res.openid_list[0].uid || 0)
              }
              storeInit(params).then(res => {
                this.isFirstPay = res.is_first_pay
              })

              // 领取安装 PWA 奖励
              if (window.localStorage.getItem('_i_p_a_') === '1' || window.localStorage.getItem('_i_p_a_pwa_directory_') === '1') {
                // 从奖励弹窗点击安装
                const params = {
                  p0: 'web',
                  p1: 18,
                  p2: 1107,
                  openid: this.userInfo.openid,
                  device_id: this.$utils.getDeviceId()
                }
                ameApiDo(params).then(res => {
                  if (window.localStorage.getItem('_i_p_a_') === '1') {
                    window.localStorage.setItem('_i_p_a_', 2)
                    this.$utils.log('save_to_desktop_reward', { save_channel: 'new_user_popup' })
                  } else if (window.localStorage.getItem('_i_p_a_pwa_directory_') === '1') {
                    window.localStorage.setItem('_i_p_a_pwa_directory_', 2)
                    this.$utils.log('save_to_desktop_reward', { save_channel: 'directory' })
                  }
                })
              }
            }
            storeLogin({ fpid: fid, uid: res.openid_list[0].uid, register_time: new Date().getTime() })
          } else {
            localStorage.setItem('openid', '')
            this.updateUserInfo({ openid: '', uid: '', real_pkg_channel: '' })
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          if (action === 'update-account-info') {
            // 绑定后不重启游戏，通知游戏 cmd - update-account-info
            this.$bus.$emit('tell-game-update-account-info')
          } else if (action !== 'new-user') {
            // loginComplete会调用游戏重启，避免重复触发
            this.$bus.$emit('loginComplete')
          }
        })
    },
    // 去充值
    toStore () {
      let utmCampaign = 'ss-webgame'
      this.$utils.consoleLog(`Header - tocharge - PWADisplayMode: ${this.$utils.getPWADisplayMode} | Platform: ${this.$utils.getPlatform}`)
      if (this.$utils.getPWADisplayMode === 'standalone') utmCampaign = `pwa-ss-webgame-${this.$utils.getPlatform}`
      this.$utils.openBrowser(`${process.env.VUE_APP_URL_STORE}?p=ss_global&c=US&cr=USD&openid=${encodeURIComponent(this.userInfo.openid)}&u=${this.userInfo.uid}&utm_campaign=${utmCampaign}&s=webgame`)
    },
    // 登出
    logout () {
      // 清理social login参数
      localStorage.removeItem('social_login_params')
      this.storeLogout()
      // 登录游客账号
      this.doVisitorLogin()
      // 关闭福利中心
      this.isShowWelfareCenter = false
    },
    // 打开客服
    openFaq () {
      console.log('==z==> Header openFaq')
      this.$utils.consoleLog('Header openFaq')
      const configJson = this.configJson || {}
      const messageJson = this.messageJson || {}
      const userInfo = this.userInfo
      const parameters = messageJson.parameters || {}
      const isRedirect = Number(parameters.is_redirect) === 1
      const path = isRedirect ? 'history' : 'main'

      let baseUrl = configJson.baseUrl
      let baseUrlv2 = configJson.baseUrlV2
      baseUrlv2 = baseUrlv2 + (baseUrlv2.endsWith('/') ? 'pc' : '/pc')
      if (configJson.isFaqV2) {
        baseUrl = configJson.baseUrlV2 === '' ? baseUrl : baseUrlv2
      }
      const jsonData = encodeURIComponent(JSON.stringify({
        fpid: userInfo.fpid,
        uid: userInfo.uid,
        autoUnMatch: 1,
        position: 'setting_assist_service',
        country_code: 'CN',
        total_pay: 0.0
      }))
      const paramsObj = {
        gameid: userInfo.gameId,
        sid: userInfo.serverId, // sever id
        game_token: userInfo.gameToken,
        channel: userInfo.pkgChannel, // package channel
        lang: userInfo.lang,
        name: userInfo.name || '',
        avatar: parameters.avatar || '',
        portrait: parameters.portrait || '',
        server_time: parameters.server_time || '',
        is_redirect: '',
        os: this.$utils.getOs('no-space'),
        sdk_version: '',
        track_key: parameters.biTrackKey || new Date().getTime(),
        device_type: this.$utils.getDeviceType(),
        os_version: this.$utils.getOsVersion(),
        app_version: '', // 同sdk_version
        rom_gb: '',
        remain_rom: 0,
        ram_mb: '',
        network_info: '',
        json_data: jsonData,
        ts: new Date().getTime()
      }
      let [queryStr, queryArr] = ['', []]
      Object.keys(paramsObj).forEach(key => {
        queryArr.push(`${key}=${paramsObj[key]}`)
      })
      queryStr = `?${queryArr.join('&')}`
      this.$utils.consoleLog('Header openFaq URL - ', `${baseUrl}${baseUrl.endsWith('/') ? '' : '/'}${path}${queryStr}`)
      this.$utils.openBrowser(`${baseUrl}${baseUrl.endsWith('/') ? '' : '/'}${path}${queryStr}`)
    },
    setWelfareUnit () {
      const w = window.innerWidth
      const h = window.innerHeight
      const relW = w / h <= 1920 / 1080 ? w : parseInt(h * 1920 / 1080)
      this.$refs.welfareCenter.style.setProperty('--unit-px', parseInt(relW / 0.192) / 10000 + 'px')
      document.body.style.setProperty('--unit-px', parseInt(relW / 0.192) / 10000 + 'px')
      document.body.style.setProperty('--unit-num', parseInt(relW / 0.192) / 10000)
    },
    // 安装PC端
    toInstallPC () {
      this.$utils.log('download_pc', { download_channel: 'directory' })
      window.open(`https://sos-pc.kingsgroupgames.com/dlfile/?clickcode=${this.$utils.clickInfo().clickcode || 'webgame'}`, '_blank')
    },
    // 静音控制
    muteControl () {
      this.isMute = !this.isMute
      localStorage.setItem('mute-control', this.isMute ? 'off' : 'on')
      this.$bus.$emit('mute-control', this.isMute ? 0 : 1)
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setWelfareUnit)
  }
}
</script>

<style lang="less" scoped>
@keyframes shake {
  70%, 80% {
    transform: rotate(12deg);
  }

  75% {
    transform: rotate(-12deg);
  }

  65%, 85% {
    transform: rotate(0);
  }
}
.header-box{
  width: 100%;
  height: @headerH;
  position: absolute;
  top: 0;
  left: 0;
  box-shadow: 0px 1px 1px 0px #DBBA64;
}
.header-wrap{
  width: 100%;
  height: @headerH;
  padding-left: 40px;
  color: #fff;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #000;
  .logo{
    width: 87px;
    height: @logoH;
    background: url(~@/assets/img/logo_ss.png) no-repeat center center;
    background-size: contain;
  }
  .right-box{
    height: 100%;
    display: flex;
    align-items: center;
  }
  .entrance-wrapper {
    position: relative;
    top: -@headerH;
    opacity: 0;
    transition: opacity .3s, top .3s;
    &.active{
      opacity: 1;
      top: 0;
    }

    .award {
      width: 48px;
      height: 27px;
      background: url(~@/assets/img/boon-entrance-award.png) no-repeat center center;
      background-size: 100%;
      // position: absolute;
      // left: -62px;
      // bottom: -2px;
    }

    .rotate {
      animation: shake 2s linear infinite alternate-reverse;
    }
  }
  .tools-wrap {
    margin-left: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .css-btn {
    font-size: 16px;
    opacity: 0;
    position: relative;
    top: -@headerH;
    transition: opacity .3s, top .3s;
    .btn-header-icon{
      width: 28px;
      height: 28px;
      background: url(~@/assets/img/icon_service_fff.png) no-repeat center center;
      background-size: 100% 100%;
    }
    &.active{
      opacity: 1;
      top: 0;
    }
  }
  .divider {
    width: 1px;
    height: 16px;
    margin: 0 30px;
    background-color: rgba(255, 255, 255, 0.3);
  }
}
.btn-recharge{
  height: 44px;
  width: 163px;
  font-size: 16px;
  font-weight: 500;
  color: #FFFFFF;
  opacity: 0;
  transition: opacity .3s, top .3s;
  position: relative;
  top: -@headerH;
  z-index: 1;
  &.active{
    opacity: 1;
    top: 0;
  }
  .discount {
    position: absolute;
    right: -26px;
    top: -14px;
    width: 57px;
    height: 49px;
    background: url(~@/assets/img/icon_off.png) no-repeat center center;
    background-size: 100% 100%;
  }
  em{
    padding: 7px 8px;
    margin-right: 4px;
    background: url(~@/assets/img/icon_member.png) no-repeat center center;
    background-size: contain;
  }
  .btn-header-icon{
    width: 26px;
    height: 22px;
    background: url(~@/assets/img/icon_diamond_fff.png) no-repeat center center;
    background-size: 100%;
  }
}
.login-box{
  height: 100%;
  padding-right: 30px;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  font-size: 16px;
  &:hover{
    .menu{
      right: 0;
      opacity: 1;
    }
    .icon-arrow-down{
      transform: rotateX(180deg);
    }
  }
  .avatar{
    width: 32px;
    height: 32px;
    margin-right: 5px;
    border-radius: 50%;
    background: url(~@/assets/img/avatar.png) no-repeat center center;
    background-size: contain;
  }
  .name{
    max-width: 111px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-left: 8px;
    margin-right: 8px;
    text-shadow: 0px 0px 4px #DCC731;
  }
  .icon-arrow-down{
    width: 16px;
    height: 16px;
    display: block;
    transition: all .3s;
    background: url(~@/assets/img/icon_arrow_down.png) no-repeat center center;
    background-size: contain;
  }
  .menu{
    height: auto;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    right: -100%;
    top: 100%;
    transition: all .3s;
    background-color: #000;
    z-index: 10001;
    .menu-item{
      min-width: 120px;
      height: 40px;
      padding: 0 10px;
      display: block;
      text-align: center;
      line-height: 40px;
      font-size: 14px;
      color: #ccc;
      transition: all .3s;
      &:hover{
        transform: scale(.95);
      }
    }
  }
}

.btn-header{
  width: 170px;
  height: 36px;
  padding-right: 4px;
  margin-left: 12px;
  color: #fff;
  font-size: 16px;
  line-height: 16px;
  border: 1px solid #9E9E9F;
  border-radius: 5px;
  background-color: #000;
  display: flex;
  gap: 2px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  position: relative;
  transition: all .3s;
  top: 0;
  opacity: 1;
  &.btn-header-s{
    width: 60px;
    padding-right: 0px;
  }
  &.hide{
    top: -@headerH;
    opacity: 0;
  }
  .btn-header-icon{
    height: 100%;
    flex-shrink: 0;
    background-position: center center;
    background-repeat: no-repeat;
  }
  .btn-header-content{
    text-align: center;
  }
}

.btn-install-pc{
  line-height: 16px;
  .btn-header-icon{
    width: 25px;
    height: 26px;
    background: url(~@/assets/img/icon_windows_fff.png) no-repeat center center;
    background-size: 100%;
  }
  .btn-header-content{
    text-align: left;
    position: relative;
    padding-bottom: 14px;
    white-space: nowrap;
    .t{
      font-weight: bold;
    }
    .b{
      font-size: 12px;
      transform: scale(0.75);
      transform-origin: 0 50%;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
}

.btn-mute{
  .btn-header-icon{
    width: 24px;
    height: 24px;
    position: relative;
    left: 3px;
    background: url(~@/assets/img/icon-sound-play.png) no-repeat center center;
    background-size: 100%;
  }
  &.mute{
    .btn-header-icon{
      background-image: url(~@/assets/img/icon-sound-mute.png);
    }
  }
}

// 手机
@media screen and (max-width: 768px) {
  .header-wrap{
    height: @m_headerH;
    .logo{
      height: @m_logoH;
    }
    .btn-recharge{
      height: 40px;
      line-height: 40px;
      border-radius: 20px;
    }
    .login-box{
      margin-left: 20px;
      .avatar{
        width: 40px;
        height: 40px;
        margin-right: 10px;
      }
      .name{
        display: none;
      }
      .icon-arrow-down{
        width: 24px;
        height: 24px;
      }
    }
    .menu{
      .menu-item{
        min-width: 130px;
        height: 54px;
        line-height: 54px;
        font-size: 20px;
      }
    }
  }
}
</style>
